import { DataTable } from '@/components/table/DataTable';
import { Text } from '@/components/ui/text';
import { useProjectsService } from '@/services/projects';
import { getPaginationRowModel } from '@tanstack/react-table';
import { useEffect, useMemo, useState } from 'react';
import { useProjectsColumns } from './columns';

interface ProjectsTableProps {
  searchString?: string;
}

export const ProjectsTable = ({ searchString = '' }: ProjectsTableProps) => {
  const columns = useProjectsColumns();
  const { projects, isPending, error } = useProjectsService();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  }, [searchString]);

  const filteredProjects = useMemo(() => {
    if (!searchString.trim()) {
      return projects || [];
    }
    const lowerSearch = searchString.toLowerCase().trim();
    return (projects || []).filter(
      p =>
        p.name.toLowerCase().includes(lowerSearch) ||
        p.description?.toLowerCase().includes(lowerSearch)
    );
  }, [projects, searchString]);

  if (error) {
    return (
      <Text variant="body-sm" color="primary">
        An error occurred
      </Text>
    );
  }

  return (
    <DataTable
      columns={columns}
      data={filteredProjects}
      isLoading={isPending}
      options={{
        getPaginationRowModel: getPaginationRowModel(),
        onPaginationChange: setPagination,
        getRowId: row => row.id,
        autoResetPageIndex: false,
        state: {
          pagination,
        },
      }}
    />
  );
};
